import {Component, DestroyRef, inject, NgZone, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {MatToolbar} from '@angular/material/toolbar';

import {
  CurrentCampaignGroupSequenceSelectService,
  CurrentLoggedInBehaviorService,
  CurrentRefreshTokenService,
  SnackBarService,
  StorageService
} from './objectPassingService';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {interval, retry, Subject, takeUntil} from 'rxjs';
import {LoginService} from './auth/login/login.service';
import {environment} from '../environments/environment';
import {NavCampaignsComponent} from './nav-campaigns/nav-campaigns.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpClient} from '@angular/common/http';
import {ClientsRootPayloadModelList} from './clients/client_interfaces';

import {AuthTokenWatchService} from './signal.store';

export interface CommitStatePayloadModel {
  this_angular_commit_id: string;
  this_api_auth_commit_id: string;
  this_api_campaignmanager_commit_id: string;
}


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatToolbar, NavCampaignsComponent],
  templateUrl: './app.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css'
})
export class AppComponent  implements OnInit {
  title = 'heal-angular-adserver';

  is_logged_in = false;
  refresh_token_service: any;
  interval_service: any;

  private destroyRef = inject(DestroyRef);
  destroyed_interval = new Subject();
  destroyed_refresh = new Subject();
  destroyed_interval_commit = new Subject();

  private _authWatcher = inject(AuthTokenWatchService);


  constructor(
    private storageService: StorageService,
    private currentLoggedInBehaviorService: CurrentLoggedInBehaviorService,
    private currentRefreshTokenService: CurrentRefreshTokenService,
    private currentLoggedInAnnouncedBehaviorSource: CurrentLoggedInBehaviorService,
    private ngZone: NgZone,
    private http: HttpClient,
    private loginService: LoginService,
    private snackBarService: SnackBarService,
    public snackBar: MatSnackBar,
    //private tokenWatch: AuthTokenWatchService


  ) {


    this.snackBarService.snackbarAnnounced$
      .pipe(takeUntilDestroyed())
      .subscribe(
        message => {
          this.openSnackBar(message, 'Dismiss');
        }); //end role_sub


  } // end of constructor

  ngOnInit() {


    //localStorage.removeItem('__storage_test__');
    this.storageService.localStorageAvailable$.pipe().subscribe(isAvailable => {
      if (!isAvailable) {
        // Handle the fallback logic here, e.g., Redis polling
        console.warn('localStorage not available!');
      } else {
        console.log('localStorage available!');
        //this.storageService.localStorageAvailable$.next(true);
      }
    });

    //this.pollingCommitIdService()
    this.currentLoggedInBehaviorService.currentLoggedInBehaviorAnnounced$
      .pipe()
      .subscribe(
        (is_logged_in: boolean) => {
          console.log('AppComponent currentLoggedInBehaviorAnnounced$', is_logged_in)
          this.is_logged_in = is_logged_in;

          if (is_logged_in) {
            //this.pollingTokenRefreshService()
          } else {
              // console.log('stop pollingTokenRefreshService')
              // if (this.refresh_token_service) {
              //   this.refresh_token_service.unsubscribe();
              // }
              // if (this.interval_service) {
              //   this.interval_service.unsubscribe();
              // }
              // this.destroyed_interval.next(''); // happens if user hits back button to got back to login page so wee need to stop the interval
              // //this.destroyed_interval.complete();  // this is not needed and will cause issues
              // this.destroyed_refresh.next('');
              // //.this.destroyed_refresh.complete(); // this is not needed and will cause issues
          }

        }
        );
  } // end of ngOnInit

//   if (commitState.adgroup_commit_id !== env.adgroup_commit_id) {
//   const userOnAdgroupPage = this.router.url.includes('/adgroups');
//
//   if (!userOnAdgroupPage) {
//   // Not actively using the module — safe to reload silently
//   this.moduleRef.destroy(); // or unload and reload route/module
//   this.router.navigateByUrl('/adgroups'); // re-lazy-loads the module
// } else {
//   // User is currently on the component — be polite
//   this.snackbar.open('Adgroup module updated. Click to reload.', 'Reload', { duration: 6000 })
//     .onAction().subscribe(() => {
//     window.location.reload(); // or soft navigate
//   });
// }
// }

  // {
  //   path: 'campaigns',
  //   loadChildren: () =>
  //     import('./campaigns/campaigns.module').then((m) => m.CampaignsModule),
  // },
  // reloadChangedModule(changedKey: string) {
  //   switch (changedKey) {
  //     case 'this_api_auth_commit_id':
  //       this.router.navigateByUrl('/auth/logout');
  //       break;
  //     case 'this_api_campaignmanager_commit_id':
  //       this.router.navigateByUrl('/campaigns/reload');
  //       break;
  //     default:
  //       window.location.reload(); // fallback to full reload
  //   }
  // }

  pollingCommitIdService() {

    console.log('AppComponent pollingCommitIdService');

    // this.ngZone.runOutsideAngular(() => {

      interval(30000).pipe( takeUntil(this.destroyed_interval_commit),
        retry(3)).subscribe(x => {
          console.log('pollingCommitIdService');
          const url = `${environment['API_URL']}/adserver/commit_state`
          this.http.get<CommitStatePayloadModel>(url).subscribe(
            (data: CommitStatePayloadModel) => {
              console.log('Commit State:', data);
              // if (
              //   data.this_api_auth_commit_id !== environment.this_api_auth_commit_id ||
              //   data.this_angular_commit_id !== environment.this_angular_commit_id
              // ) {
              //   window.location.reload(); // or show a drift banner
              // }

            },
            (error) => {
              console.error('Error fetching commit state:', error);
            }
          );
        }, (error) => {
          console.log('error from b1', error)

        }, () => { }
      ) // end of interval
    // }) // end of ngZone
  } //end pollingCommitIdService()


  pollingTokenRefreshService() {

    this.ngZone.runOutsideAngular(() => {

      console.log('pollingTokenRefreshService')


      this.interval_service = interval(10000).pipe( takeUntil(this.destroyed_interval),
        retry(3)).subscribe(x => {
          const url = `${environment.API_AUTH_URL}/refresh`
          const username = localStorage.getItem('username')!;
          const refresh_token = localStorage.getItem('refresh_token')!;
          const id_token = localStorage.getItem('id_token')!;
          const exp = localStorage.getItem('exp')! as unknown as number;
          const current_time = new Date().getTime() / 1000;
          const time_left = exp - current_time;
          //console.log('login bootstrap expirationDuration', time_left, 'this.is_logged_in', this.is_logged_in)

          if (refresh_token === null) {
            console.log('refresh token is null', refresh_token)
            this.currentRefreshTokenService.announceRefreshToken(false)
            //this.currentLoggedInBehaviorService.announceCurrentLoggedInBehavior(false)
            this.destroyed_interval.next('');
            //this.destroyed_interval.complete();
            this.destroyed_refresh.next('');
            //this.destroyed_refresh.complete();
          }


          if (time_left < 60 && refresh_token) {
            this.loginService.refreshToken(url, username, refresh_token).pipe().subscribe(x => {
              console.log('refresh token', x)
              console.log(username)
            }, (error) => {
              this.currentRefreshTokenService.announceRefreshToken(false)
              //this.currentLoggedInBehaviorService.announceCurrentLoggedInBehavior(false)
              this.destroyed_interval.next(''); // happens if user hits back button to got back to login page so wee need to stop the interval
              //this.destroyed_interval.complete();
              this.destroyed_refresh.next('');
              //this.destroyed_refresh.complete();
              console.log('error from a1', error)
              this.loginService.logout();
            }, () => { });
          } else {
            //console.log('token is still valid')
          }
        }, (error) => {
          console.log('error from b1', error)
          this.currentRefreshTokenService.announceRefreshToken(false)
          //this.currentLoggedInBehaviorService.announceCurrentLoggedInBehavior(false)
          this.destroyed_interval.next(''); // happens if user hits back button to got back to login page so wee need to stop the interval
          //this.destroyed_interval.complete();
          this.destroyed_refresh.next('');
          //this.destroyed_refresh.complete();
          this.loginService.logout();
        }, () => { }
      ) // end of interval

    }) // end of ngZone
  } //end pollingTokenRefreshService()

  openSnackBar(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 5000,
    });
    snackBarRef.afterDismissed().subscribe(() => {
      console.log('The snack-bar was dismissed');
    });
    snackBarRef.onAction().subscribe(() => {
      console.log('The snack-bar action was triggered!');
    });
    //snackBarRef.dismiss();
  } //end openSnackBar






} // end of class AppComponent
